// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\na.router-link-active[data-v-d02591be] {\n  color: #EE1C25 !important;\n}\n.icon-selected[data-v-d02591be] {\n  display: none !important;\n}\na.router-link-active .icon-selected[data-v-d02591be] {\n  display: block !important;\n}\na.router-link-active .icon-unselected[data-v-d02591be] {\n  display: none !important;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
